'use client';
import { StepperStep } from '@/components/NewGeneralDialog/DialogStepper';
import { GeneralDialogContext } from '@/context/GeneralDialogContext';
import { toNumber } from 'lodash';
import { ReactNode, useState } from 'react';

interface Props {
  children: ReactNode;
  activeStepIndex?: number;
  steps?: StepperStep[];
}

export const GeneralDialogProvider = (props: Props) => {
  const { steps, children } = props;
  const [activeStepIndex, setActiveStepIndex] = useState<number>(
    toNumber(props.activeStepIndex || 0)
  );
  const [isStepperVisible, setIsStepperVisible] = useState(true);

  const moveForward = () =>
    setActiveStepIndex((prevActiveStep) => prevActiveStep + 1);

  const moveBackward = () =>
    setActiveStepIndex((prevActiveStep) => prevActiveStep - 1);

  const hideStepper = () => setIsStepperVisible(false);

  const showStepper = () => setIsStepperVisible(true);

  const moveToStep = (stepIndex: number) => setActiveStepIndex(stepIndex);

  return (
    <GeneralDialogContext.Provider
      value={{
        steps,
        activeStepIndex,
        isStepperVisible,
        moveForward,
        moveBackward,
        moveToStep,
        showStepper,
        hideStepper,
      }}>
      {children}
    </GeneralDialogContext.Provider>
  );
};
